import { gql, GraphQLClient } from 'graphql-request'

import { KardexPeriodoInput, KardexPeriodoProps } from '../../../base/interfaces'
import { AccessToken } from '../../../base/models/paramsModel'
import { MyGraphQlError } from '../../../base/services/GraphqlError'

const query = gql`
  mutation INICIAR_OPERACIONES($input: KardexPeriodoInput!) {
    kardexPeriodoIniciar(input: $input) {
      codigo
      descripcion
      documentoSector {
        codigoClasificador
        descripcion
      }
      state
    }
  }
`

export const apiKardexPeriodoIniciar = async (
  input: KardexPeriodoInput,
): Promise<KardexPeriodoProps> => {
  const client = new GraphQLClient(import.meta.env.ISI_API_URL)
  const token = localStorage.getItem(AccessToken)
  // Set a single header
  client.setHeader('authorization', `Bearer ${token}`)
  const data: any = await client.request(query, {
    input: input,
  })
  return data.kardexPeriodoIniciar
}
